import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import {
  getTalentCertifications,
  type GetTalentCertificationsParams,
} from './talentCertificationsApi';

export const TALENT_CERTIFICATIONS_QUERY_KEY = ['talent', 'certifications'] as const;

export function useTalentCertifications(params: GetTalentCertificationsParams) {
  return useQuery({
    queryKey: [
      ...TALENT_CERTIFICATIONS_QUERY_KEY,
      params.shortlistPublicKey,
      params.talentPublicKey,
    ],
    queryFn: () => getTalentCertifications(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
